<template lang="pug">
.container
  .buttons.float-right(v-if='device.DeviceDesktops[0].uuid')
    el-button(id="DeviceRequests-addButton", type="success", size="small", @click="sendRequestVisible = true")
      font-awesome-icon(icon="plus")
  .warning(id="DeviceRequests-noUUIDWarning", v-else)
    span {{ $t('Cannot send custom requests to this device, beacuse it has no UUID defined, please refer to Monitors tab.') }}
  .requests
    table
      tr(v-if='requests.length > 0')
        th
          span {{ $t('Method') }}
        th
          span {{ $t('Arguments') }}
        th
          span {{ $t('Status') }}
        th
          span {{ $t('Last updated') }}
        th
          span {{ $t('User') }}
      tr(v-for='request in requests', :key='request.id', :id="'DeviceRequests-row' + request.id")
        td {{ request.method }}
        td.arguments
          div(v-if='typeof request.arguments === "object"', v-for='key of Object.keys(request.arguments)') {{ key }}: {{ request.arguments[key] }}
        td
          el-button.response-data(v-if='request.responseRaw && request.responseRaw !== true', size="mini", type="text", @click='showResponseRaw(request)') {{ $t(request.status) }} &nbsp;
            font-awesome-icon.info-icon(v-if="request.responseRaw", icon="info-circle")
          span.no-response-data(v-else) {{ $t(request.status) }} {{ request.status === 'pending' ? '...' : ''}}
        td {{ humanTime(request.updatedAt) }}
        td {{ getNickFromUserId(request.userId) }}
  el-dialog(:close-on-click-modal="false", :visible.sync='sendRequestVisible', @close='closeSendRequest()', append-to-body, width="30%")
    SendRequest(id="DeviceRequests-sendRequest" :device='device', @requestSent='closeSendRequest')
  el-dialog(:close-on-click-modal="true", :visible.sync='showResposeVisible', @close='closeShowRespose()', append-to-body, width="100%")
    .header
      span {{ $t('Raw output of Response for Request:') }}
      span.float-right
      el-button(type="success", size="mini", @click="copyOutput(requestData.responseRaw)", :title="$t('Copy output to clipboard')")
        font-awesome-icon(icon="copy")
    hr.header
    .output(v-if='requestData && requestData.responseRaw')
      div.selectable(v-if='requestData.responseRaw.stderr')
        h3.danger STDERR:
        div.output(v-for='line of getLinesArrayFromString(requestData.responseRaw.stderr)') {{ line }}
      div.selectable(v-if='requestData.responseRaw.stdout')
        h3.success STDOUT:
        div.output(v-for='line of getLinesArrayFromString(requestData.responseRaw.stdout)') {{ line }}
      div.selectable(v-if='requestData.responseRaw.name')
        h3.success RESPONSE:
        h3.output {{ requestData.responseRaw.name }}
        div.output {{ requestData.responseRaw.message }}
      div.selectable(v-if='!requestData.responseRaw.name && !requestData.responseRaw.stderr && !requestData.responseRaw.stdout')
        h3.success RESPONSE:
        pre.output {{ requestData.responseRaw }}
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'
import SendRequest from './SendRequest'

export default {
  mixins: [textUtils],
  components: {
    SendRequest
  },
  props: ['side', 'device'],
  data () {
    return {
      errors: {
      },
      loading: false,
      requests: [],
      sendRequestVisible: false,
      showResposeVisible: false,
      requestData: ''
    }
  },
  watch: {
    device: async function (newVal, oldVal) {
      await this.load()
    }
  },
  async created () {
    await this.load()
  },
  async beforeDestroy () {
    await Vue.$io.socket.post('/request/unsubscribeFromRequests', {
      requests: this.requests.filter(request => request.status === 'pending').map(request => request.id)
    })
  },
  methods: {
    showResponseRaw (request) {
      this.requestData = request
      // for (const key of Object.keys(this.responseRaw)) {
      //   console.log(key)
      // }
      // if (this.responseRaw.stdout) this.responseRaw.stdout = JSON.parse(this.responseRaw.stdout)
      this.showResposeVisible = true
    },
    closeShowRespose () {
      this.requestData = ''
      this.showResposeVisible = false
    },
    copyOutput (responseRaw) {
      navigator.clipboard.writeText(JSON.stringify(responseRaw))
    },
    async closeSendRequest (request) {
      this.sendRequestVisible = false
      // const that = this
      setTimeout(async () => {
        await this.load()
      }, 1000)
    },
    async load () {
      this.requests = []
      this.loading = true
      for (const desktop of this.device.DeviceDesktops) {
        await Vue.axios
          .get(`Request?DeviceDesktop=${desktop.id}&sort=id%20DESC&limit=30`)
          .then(response => {
            this.requests = response.data
          })
      }
      Vue.$io.socket.off('request')
      Vue.$io.socket.on('request', (msg) => {
        const requestUpdated = this.requests.find(rqst => rqst.id === msg.request.id)
        requestUpdated.status = msg.request.status
      })
      await Vue.$io.socket.post('/request/subscribeToRequests', {
        requests: this.requests.map(request => request.id)
      })
      this.loading = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.buttons {
  margin-bottom: 30px;
}
table {
  width:100%;
  border-spacing: 0;
  th {
    text-align:left;
  }
  tr {
    td {
      border-bottom: $--border-light;
      font-size: $--font-size-base;
      padding: 10px 0px;
      &.arguments {
        max-width: 250px;
        overflow: hidden;
      }
    }
  }
}
.no-response-data {
  color: $--color-info;
}
.response-data {
  color: $--color-success;
}
.info-icon {
  font-size: $--font-size-big;
}
.responseRaw {
  width: 300px;
  background-color: black;
}
.output {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceRequests.vue